import { render, staticRenderFns } from "./onBeforeUpload-editor.vue?vue&type=template&id=6985c67c&scoped=true&"
import script from "./onBeforeUpload-editor.vue?vue&type=script&lang=js&"
export * from "./onBeforeUpload-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6985c67c",
  null
  
)

export default component.exports